import { render, staticRenderFns } from "./MoreInfoView.vue?vue&type=template&id=6d3223c1&scoped=true&"
import script from "./MoreInfoView.vue?vue&type=script&lang=ts&"
export * from "./MoreInfoView.vue?vue&type=script&lang=ts&"
import style0 from "./MoreInfoView.vue?vue&type=style&index=0&id=6d3223c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3223c1",
  null
  
)

export default component.exports